import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { successToast } from '@components/toasts/Toasts';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { getAdminById, updateAdminById } from './apiHelpers';
import type { EditTeamMemberFormData } from './EditTeamMemberPage';

export const useFetchAdmin = () => {
  const { adminId } = useParams();
  const { id: restaurantId } = useRestaurant();

  return useQuery({
    queryKey: ['restaurants', restaurantId, 'restaurantAdmins', adminId],
    queryFn: () => getAdminById(restaurantId, adminId!),
    enabled: !!adminId,
  });
};

export const useUpdateAdminMutation = () => {
  const navigate = useNavigate();
  const { adminId } = useParams();
  const { id: restaurantId } = useRestaurant();

  return useMutation({
    mutationFn: ({
      role,
      reservationEmailsEnabled,
    }: EditTeamMemberFormData) => {
      return updateAdminById(restaurantId, adminId!, {
        role,
        reservationEmailsEnabled,
      });
    },
    onSuccess: () => {
      successToast({ message: 'Team member successfully updated!' });
      navigate(-1);
    },
  });
};
